import React, { useState, useEffect } from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import { useOnboardingContext } from 'frontend/src/contexts/Onboarding';
import messages from '../../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert from '../../BuildingBlocks/Alert/Alert';
import Typography from '@material-ui/core/Typography';
import GlowingButton from '../../BuildingBlocks/Button/GlowingButton';
import { is8DataApp, providerName } from '../../../utils';

const useStyles = makeStyles((theme) => ({
  root: { width: '100%', maxWidth: 600, margin: theme.spacing(2) },
  content: { display: 'flex', alignItems: 'center' },
  text: { fontWeight: 'bold' },
  seperator: {
    marginLeft: theme.spacing(0.75),
    marginRight: theme.spacing(0.75),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: theme.spacing(1),
  },
}));

const TEXT_8DATA = `We’ve planned your supply chain for the next 12-months. ${providerName} will gradually improve its planning as we learn your sales volatility and seasonality. You can also add more products by clicking on '+'.`;

export default function GeneratedLinesForYouAlert() {
  const classes = useStyles();
  const { loading } = useLinesContext();
  const { justCompletedOnboarding } = useOnboardingContext();

  const [open, setOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const [initialLoadingStarted, setInitialLoadingStarted] = useState(false);
  const [initialLoadingEnded, setInitialLoadingEnding] = useState(false);

  const is8Data = is8DataApp();

  function handleClose() {
    setOpen(false);
  }

  useEffect(() => {
    if (loading) {
      setInitialLoadingStarted(true);
    }
    if (!loading && !hasBeenOpened && initialLoadingStarted) {
      setInitialLoadingEnding(true);
      setOpen(true);
      setHasBeenOpened(true);
    }
  }, [loading, initialLoadingStarted, hasBeenOpened]);

  return (
    <>
      {initialLoadingEnded && justCompletedOnboarding && (
        <Alert open={open}>
          <div className={classes.root}>
            <div className={classes.content}>
              <Typography paragraph className={classes.text}>
                {is8Data
                  ? TEXT_8DATA
                  : messages.lines.onboarding.generatedLines}
              </Typography>
              <div className={classes.seperator} />
              <img src={'general/linesExample.png'} alt="" />
            </div>
            <div className={classes.buttonContainer}>
              <GlowingButton onClick={handleClose} data-automation-id="gotIt">
                Got it
              </GlowingButton>
            </div>
          </div>
        </Alert>
      )}
    </>
  );
}
